import React, {useEffect}from "react";
import ProgressBar from '../../../../partials/ProgressBar'
import "./RocketFit.scss";


const RocketFit = (props) => {
  
  const { rocket, maxSizeVolume, maxMass, maxOrbit} = props; 

  useEffect(() => {
    
  }, [ rocket ]) 

  const calcSize = (height, diameter, max) => {

    // const radius = diameter / 2;
    // const volume = height * Math.PI * radius;

    return parseInt(((diameter/max) * 100).toFixed(3));

  }
  const calcMass = (mass, max) => {
    return parseInt(((mass/max) * 100).toFixed(3));
  }
  const calcOrbit = (orbit, max) => {
    return parseInt(((orbit/max) * 100).toFixed(3));
  }

  return (
      <div className='rocketfit-container'>

          <div className="rocketfit-grid">

            <div className="rocketfit-headers row">
              <div className="column">Rocket Fit:</div>

              <div className="rocketfit-data column">
                <div>Undersized</div>
                <div>Oversized</div>
              </div>
             
            </div>
            
            <div className="rocketfit-specs row">
              
              <div className="rocketfit-name column">Satellite Size:</div>
              <div className="rocketfit-progressbar column">
                <ProgressBar pct={calcSize(rocket.height.max, rocket.diameter, maxSizeVolume)} />
              </div>
            </div>

            <div className="rocketfit-specs row">
              
              <div className="rocketfit-name column">Satellite Mass:</div>
              <div className="rocketfit-progressbar column">
                <ProgressBar pct={calcMass(rocket.mass,maxMass)} />
              </div>
            </div>

            <div className="rocketfit-specs row">
              
              <div className="rocketfit-name column">Satellite Orbit:</div>
              <div className="rocketfit-progressbar column">
                <ProgressBar  pct={calcOrbit(rocket.orbit,maxOrbit)}/>
              </div>
            </div>
          </div>

        
      </div>
  );
};

const SVGLine = () => {
  return (
    <svg id="chart" width="100%" height="100%">
      <line x1="65%" x2="65%" y1="5%"  y2="100%"></line>
    </svg>
  )
}

export default RocketFit;